import Vue from 'vue'
import filters from './filters/filters'
import './exported-components'

// Registrér globale filtre så alle komponenter kan bruge $filters i templates
Vue.prototype.$filters = filters
import VueRouter from 'vue-router'
import VueI18n from 'vue-i18n'
import store from './store'
import VueTouch from 'vue-touch'
import App from './App.vue'
import moment from 'moment'
import 'jspolyfill-array.prototype.findIndex'
import generalHelpers from './helpers/general-helpers'
import ComponentViewer from './ComponentViewer'
import VueObserveVisibility from 'vue-observe-visibility'

// components
import Show from './components/Show.vue'
import SubsOverviewToday from './components/Subs/OverviewTodayAbsentPublic'
import Public from './components/public/PublicContainer.vue'
import VueYoutube from 'vue-youtube'
import VueTippy from './vue-tippy.min.js'
import GrundskoleIndberetning from './components/Reporting/GrundskoleIndberetning'
import Timetalsindberetning from './components/Reporting/Timetalsindberetning.vue'
import SchoolData from './components/SchoolData/SchoolData'
import Profile from './components/Profile/ProfileSSN'
import KompetenceIndberetning from './components/Reporting/KompetenceIndberetning/KompetenceIndberetning'
import SchoolDataAbsence from './components/SchoolData/SchoolDataAbsence'
import Calendar from './components/Calendars/DoCalendar'
import SchoolDataSubsAbsenceType from './components/SchoolData/SchoolDataSubsAbsenceType'
import SchoolDataCoverage from './components/SchoolData/SchoolDataCoverage'
import SchoolDataSubContinuity from './components/SchoolData/SchoolDataSubContinuity'
import SchoolDataAbsenceDuration from './components/SchoolData/SchoolDataAbsenceDuration'
import DutySchedule from './components/DutySchedule/DutySchedule.vue'
import DoHeader from './components/DoHeader.vue'
import Substitution from './components/Substitution/Substitution.vue'
import Academy from './components/Academy/Academy.vue'
import HelpDesk from './components/Helpdesk/Helpdesk.vue'
import SalaryOverview from './components/Salary/Salary.vue'

Vue.use(VueTippy, {
  directive: 'tippy', // => v-tippy
  popperOptions: {
    modifiers: {
      preventOverflow: {
        enabled: false
      }
    }
  }
})

// ROUTER
Vue.use(VueRouter)
Vue.use(generalHelpers)
Vue.use(VueYoutube)
Vue.use(VueObserveVisibility)

Vue.use(VueTouch, {name: 'v-touch'})

const router = new VueRouter({
  routes: [
    {
      path: '/subs/:school_id', components: {
        default: Substitution,
        SideNav: SideNav,
        Header: DoHeader
      }
    },
    {
      name: 'Plan',
      path: '/plan/:school_id', components: {
        default: DutySchedule,
        SideNav: SideNav,
        Header: DoHeader
      }
    },
    {path: '/', component: ComponentViewer},
    {path: '/public/:calendar_id', component: Public},
    {path: '/public/substitutes_teachers_show/:school_uuid', component: SubsOverviewToday},
    {path: '/show', component: Show},
    {
      path: '/calendar/:calendar_id',
      components: {
        default: Calendar,
        SideNav: SideNav,
        Header: DoHeader
      }
    },
    {path: '/dashboard/:school_id', component: SchoolData},
    {path: '/dashboard/absence/:school_id', component: SchoolDataAbsence},
    {path: '/dashboard/absence/subs/:school_id', component: SchoolDataSubsAbsenceType},
    {path: '/dashboard/absence/duration/:school_id', component: SchoolDataAbsenceDuration},
    {path: '/dashboard/coverage/:school_id', component: SchoolDataCoverage},
    {path: '/dashboard/continuity/:school_id', component: SchoolDataSubContinuity},
    {
      path: '/grundskoleindberetning/:school_id',
      components: {
        default: GrundskoleIndberetning
      }
    },
    {path: '/timetalsindberetning/:school_id', component: Timetalsindberetning},
    {
      path: '/kompetenceindberetning/:school_id',
      components: {
        default: KompetenceIndberetning
      }
    },
    {
      path: '/users/:user_id',
      components: {
        default: Profile
      }
    },
    {path: '/academy/:school_id', component: Academy},
    {path: '/helpdesk', component: HelpDesk},
    {
      path: '/salary-overview/:school_id', components: {
        default: SalaryOverview,
        SideNav: SideNav,
        Header: DoHeader
      }
    }
  ]
})

// I18N
import da from './i18n/da'
import nb from './i18n/nb'
import en from './i18n/en'
import SideNav from './components/SideNav'

Vue.use(VueI18n)

// vue-i18n 6's `messages` getter deep-clones every locale (JSON round-trip) on each $t call
Vue.prototype.$t = function (key, ...values) {
  const i18n = this.$i18n
  return i18n._t(key, i18n.locale, i18n._vm.messages, this, ...values)
}
Vue.prototype.$tc = function (key, choice, ...values) {
  const i18n = this.$i18n
  return i18n._tc(key, i18n.locale, i18n._vm.messages, this, choice, ...values)
}
Vue.prototype.$te = function (key, locale) {
  const i18n = this.$i18n
  return i18n._te(key, i18n.locale, i18n._vm.messages, locale)
}

/* ONLY FOR LOCALTESTING IN VUE
if (window.location.hostname === 'localhost') {
  window.USER = {
    id: 13,
    name: 'Henrik R',
    settings: '{}',
    language: 'da',
    locale: 'da'
  }
  window.SCHOOL = {
    id: 7272, // 7272, // OPUS 61821, // 62084 Nørretranders
    name: 'Solsorten',
    country: 'dk',
    state: 'customer',
    first_day_of_week_num: 1,
    features: ['silkeborg_data_integration'],
    salary_system: 'KMD' // 'SD' // 'KMD'
  }
  console.log('LOCALHOST', window.SCHOOL)
}
// */

// Create VueI18n instance with options

let fallBackTLD = 'en'
if (window.location.host.indexOf('.dk') > -1) {
  fallBackTLD = 'da'
} else if (window.location.host.indexOf('.no') > -1) {
  fallBackTLD = 'nb'
}

const i18n = new VueI18n({
  locale: window.USER && window.USER.language ? window.USER.language : fallBackTLD,
  fallbackLocale: fallBackTLD,
  messages: {
    da: da.da,
    nb: nb.nb,
    nn: nb.nb,
    en: en.en
  }
})
const userLocale = window.USER && window.USER.locale ? window.USER.locale : 'en'
moment.locale(userLocale)

// required for Rails to "see" Vue-i18n + messages in global scope
window.use_i18n = i18n
window.use_vuex = store

// APP
// Now the app has started!
const pageApp = new Vue({
  i18n,
  store,
  el: '#app',
  router: router,
  render: h => h(App)
})

// expose the app, the router and the store.
// note we are not mounting the app here, since bootstrapping will be
// different depending on whether we are in a browser or on the server.
export default {pageApp, router, i18n}



// WEBPACK FOOTER //
// ./src/main.js